import { styled } from '@mui/material';

import { Screen } from '@/components/Layout/Screen';

import { getAssetPath } from '@/constants/configs';

export const Logo = styled(
  (props: React.ImgHTMLAttributes<HTMLImageElement>) => (
    <img src={getAssetPath('/logo-with-text.svg')} {...props} />
  ),
)(({ theme }) => ({
  margin: `${theme.spacing(8)} auto ${theme.spacing(12)}`,
  width: 206,
}));

export const Clock = styled(
  (props: React.ImgHTMLAttributes<HTMLImageElement>) => (
    <img src={getAssetPath('/bg-time-mobile.png')} {...props} />
  ),
)(({ theme }) => ({
  margin: `${theme.spacing(2)} auto ${theme.spacing(7)}`,
  width: 170,
}));

export const StyledFinishedScreen = styled(Screen)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  position: 'fixed',
  top: 0,
  left: 0,
}));

export const FinishedLogo = styled(
  (props: React.ImgHTMLAttributes<HTMLImageElement>) => (
    <img src={getAssetPath('/logo-with-text.svg')} {...props} />
  ),
)(({ theme }) => ({
  margin: `${theme.spacing(24)} auto ${theme.spacing(10)}`,
  height: 'auto',
  width: 206,
}));

export const StyledCaymanValidationFailedScreen = styled(Screen)(
  ({ theme }) => ({
    backgroundColor: theme.palette.background.paper,
    position: 'fixed',
    top: 0,
    left: 0,
    height: '100%',
  }),
);

export const CaymanCountryLogoWithText = styled(
  (
    props: React.ImgHTMLAttributes<HTMLImageElement> & {
      'data-test-id'?: string;
    },
  ) => (
    <img
      src={getAssetPath('/cayman-logo-with-text.svg')}
      width={248}
      {...props}
    />
  ),
)();
